// External libraries
import stylisRTL from 'stylis-plugin-rtl';
import legacyStylisRTL from 'stylis-plugin-rtl-legacy';
import createCacheLegacy from '@emotion/cache-legacy';
import createCache from '@emotion/cache';

// Internal modules
import { getGlobals, isRtlLang } from '@/lib/globals';

const { nonce } = getGlobals();

export enum EMOTION_CACHE_KEYS {
  LTR = 'ltr',
  RTL = 'rtl',
}

// Emotion Cache Config Settings
const ltrConfig = {
  key: 'css-ltr',
  nonce,
  stylisPlugins: [],
};

export const EMOTION_CACHE = {
  [EMOTION_CACHE_KEYS.LTR]: createCache(ltrConfig),
  [EMOTION_CACHE_KEYS.RTL]: createCache({
    key: 'css-rtl',
    nonce,
    stylisPlugins: [stylisRTL],
  }),
} as const;

export const LEGACY_EMOTION_CACHE = {
  [EMOTION_CACHE_KEYS.LTR]: createCacheLegacy(ltrConfig),
  [EMOTION_CACHE_KEYS.RTL]: createCacheLegacy({
    key: 'css-rtl',
    nonce,
    stylisPlugins: [legacyStylisRTL],
  }),
} as const;

export const getEmotionCacheKey = (): EMOTION_CACHE_KEYS => {
  return isRtlLang() ? EMOTION_CACHE_KEYS.RTL : EMOTION_CACHE_KEYS.LTR;
};
